import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import intlShape from '@/shared/utils/intlShape';
import { useGetLegalEntityNames } from '@/shared/hooks/legalEntity/useGetLegalEntityNames';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';

const messages = defineMessages({
  LegalEntities: 'Legal entities',
});

function LegalEntityMultiSelect({ selection, onChange, intl, placeholder = null }) {
  const { data, isLoading } = useGetLegalEntityNames();
  if (isLoading || !data) return null;
  const entities = data.map(x => ({ ...x, label: x.name })).sort(dynamicSort('label'));
  const [selectedItems, selectableItems] = splitItems(entities, selection);
  return (
    <MultiSelect
      selectedItem={selectedItems}
      onItemRemoved={item => onChange(removeItem(selection, item))}
      onItemSelected={item => onChange(addItem(selection, item))}
      items={selectableItems}
      placeholder={placeholder || intl.formatMessage(messages.LegalEntities)}
    />
  );
}

LegalEntityMultiSelect.propTypes = {
  selection: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  intl: intlShape.isRequired,
};

export default injectIntl(LegalEntityMultiSelect);
